import styled from "styled-components";
import bannerImg from "../../images/bannerimg.webp";

export const DashboardWrapper = styled.div`
  .carde {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 18px;
    margin-block: 28px;

    > div { width: 100%; max-width: none; }

    @media only screen and (max-width: 992px) {
      grid-template-columns: repeat(2, 1fr);
    }
    @media only screen and (max-width: 600px) {
      grid-template-columns: 1fr;
    }
  }

  .banner {
    gap: 18px;
    margin-block: 28px;
    flex-wrap: wrap;
    .card {
      background: #fff;
      box-shadow: 0 4px 18px rgba(28,38,52,0.05);
      border: 1px solid #e8eee5;
      border-radius: 16px;
      flex: 1 1 30%;
      max-width: 420px;
      min-width: 280px;
      min-height: 242px;

      &.card1 {
        background: linear-gradient(135deg, #1C2634, #243140);
        padding: 30px 24px;
        position: relative;
        overflow: hidden;
        border: none;

        &::after {
          content: '';
          position: absolute;
          width: 200px; height: 200px;
          border-radius: 50%;
          background: rgba(80,149,64,0.15);
          top: -80px; right: -60px;
        }

        h2 {
          color: #fff;
          font-size: 24px;
          line-height: 1.3;
          font-weight: 800;
          position: relative;
          z-index: 1;
        }
      }

      &.card2 {
        overflow: hidden;
        img {
          width: 100%;
          transform: scale(1.02);
          background-color: #000000a1;
        }
        .play {
          gap: 8px;
          padding: 20px;
          img { width: 17px; background-color: transparent; }
          h2 { font-size: 15px; color: #1C2634; font-weight: 700; }
        }
      }

      &.card3 {
        padding: 24px;
        h3 { font-size: 16px; margin-bottom: 12px; color: #1C2634; font-weight: 800; }
        p { font-size: 13.5px; line-height: 1.65; margin-bottom: 14px; color: #666; }
      }
    }
  }

  @media only screen and (max-width: 768px) {
    .hideMD { display: none; }
  }
`;

export const DashboarCarddWrapper = styled.div`
  display: flex;
  gap: 14px;
  padding: 22px 22px;
  background: #fff;
  border: 1px solid #e8eee5;
  box-shadow: 0 4px 18px rgba(28,38,52,0.04);
  border-radius: 16px;
  min-height: 130px;
  transition: all 0.3s;
  cursor: pointer;
  position: relative;
  overflow: hidden;

  &::before {
    content: '';
    position: absolute;
    top: 0; left: 0;
    width: 4px;
    height: 100%;
    background: transparent;
    transition: background 0.3s;
  }

  &:hover {
    transform: translateY(-4px);
    box-shadow: 0 12px 28px rgba(80,149,64,0.12);
    border-color: #509540;

    &::before { background: linear-gradient(180deg, #509540, #6dd05a); }

    .icons {
      background: linear-gradient(135deg, #509540, #3d7a30) !important;
      color: #fff !important;
      transform: scale(1.12) rotate(-8deg);
      border-radius: 50% !important;
      box-shadow: 0 10px 24px rgba(80,149,64,0.40);
      img {
        filter: brightness(0) invert(1) !important;
        transform: scale(1.15) rotate(8deg);
      }
      svg { transform: scale(1.15) rotate(8deg); }
    }
  }

  &.current {
    background: linear-gradient(135deg, #509540, #3d7a30);
    color: #fff;
    border-color: #509540;
    box-shadow: 0 12px 32px rgba(80,149,64,0.35);

    &::before { background: rgba(255,255,255,0.4); }

    .icons {
      background: rgba(255,255,255,0.18);
      color: #fff;
      img { filter: brightness(0) invert(1); }
    }
    .rightBox {
      .header h2 { color: #fff; }
      p { color: rgba(255,255,255,0.85); }
    }
  }

  &.completed {
    background: #f8fbf6;
    border-color: #d8eed2;

    .icons {
      background: linear-gradient(135deg, #509540, #3d7a30);
      color: #fff;
      img { filter: brightness(0) invert(1); }
    }
  }

  &.disabled {
    opacity: 0.85;
    cursor: not-allowed;
    &:hover {
      transform: translateY(-2px);
      border-color: #d8eed2;
      box-shadow: 0 6px 18px rgba(80,149,64,0.08);
      &::before { background: linear-gradient(180deg, #509540, #6dd05a); }
      .icons {
        background: linear-gradient(135deg, #509540, #3d7a30) !important;
        color: #fff !important;
        transform: scale(1.12) rotate(-8deg);
        border-radius: 50% !important;
        box-shadow: 0 10px 24px rgba(80,149,64,0.40);
        img {
          filter: brightness(0) invert(1) !important;
          transform: scale(1.15) rotate(8deg);
        }
        svg { transform: scale(1.15) rotate(8deg); }
      }
    }
  }

  .icons {
    width: 56px;
    height: 56px;
    min-width: 56px;
    background: #f0f7ed;
    color: #509540;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 14px;
    transition: all 0.35s cubic-bezier(0.34, 1.56, 0.64, 1);
    flex-shrink: 0;

    img, svg {
      width: 28px;
      height: 28px;
      transition: all 0.35s cubic-bezier(0.34, 1.56, 0.64, 1);
    }

    &.active {
      background: linear-gradient(135deg, #509540, #3d7a30);
      color: #fff;
      img { filter: brightness(0) invert(1); }
    }
  }

  .rightBox {
    width: 100%;

    .header {
      justify-content: space-between;
      gap: 10px;
      width: 100%;
      margin-bottom: 6px;

      h2 {
        font-size: 15.5px;
        font-weight: 700;
        color: #1C2634;
        font-family: 'Poppins', sans-serif;
      }
    }

    p {
      font-size: 13px;
      line-height: 1.55;
      color: #666;
      margin: 0;
      font-family: 'Poppins', sans-serif;
    }
  }

  @media only screen and (max-width: 768px) {
    margin-inline: auto;
  }
`;
